/**
 * Created by slava on 24.03.17.
 */

const ExtendUnlimitedLivesWindow = CleverappsWindow.extend({ 
    onWindowLoaded: function () {
        const styles = cleverapps.styles.ExtendUnlimitedLivesWindow;

        const animation = this.createAnimation();

        const text = this.createText();

        this.product = Product.CreateById("unlimitedLives");

        const content = new cleverapps.Layout([animation, text], {
            margin: styles.margin,
            direction: cleverapps.UI.VERTICAL,
            padding: styles.padding
        });

        this._super({
            content,
            title: Messages.get("ExtendUnlimitedLivesWindow.title"),
            name: "extendunlimitedliveswindow",
            button: {
                text: this.getButtonText(),
                width: styles.button.width,
                height: styles.button.height,
                onPressed: this.onBuy.bind(this)
            },
            openSound: bundles.extend_unlimited_lives_window.urls.lives_effect
        });

        if (this.product.currency === "hard") {
            cleverapps.focusManager.showControlsWhileFocused("MenuBarGoldItem");
        }

        cleverapps.paymentsLogic.onChangeStatus(this.updateButton.bind(this), this);

        this.updateButton();
    },

    updateButton: function () {
        if (connector.payments.isConnected()) {
            this.buttons.enable();
        } else {
            this.buttons.disable();
        }
    },

    getPerson: function () {
        return {
            role: "hero",
            emotion: "sad"
        };
    },

    createText: function () {
        const styles = cleverapps.styles.ExtendUnlimitedLivesWindow;

        const text = cleverapps.UI.generateOnlyText(Messages.get("ExtendUnlimitedLivesWindow.unlimitedLivesText"), cleverapps.styles.FONTS.WINDOW_TEXT);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.setDimensions(styles.text.width, styles.text.height);

        return text;
    },

    createAnimation: function () {
        const styles = cleverapps.styles.ExtendUnlimitedLivesWindow;

        const node = new cc.Node();
        node.setAnchorPoint(0.5, 0.5);
        node.setContentSize2(styles.animation);

        const animation = new cleverapps.Spine(bundles.extend_unlimited_lives_window.jsons.lives_json);
        if (["differences", "tripeaks", "olympics", "spades", "zenmatch"].indexOf(cleverapps.config.name) !== -1) {
            animation.setAnimationAndIdleAfter("no_life", "idle");
        } else {
            animation.setAnimation(0, "no_life", true);
        }

        node.addChild(animation);
        animation.setAlignment(styles.animation);

        return node;
    },

    onBuy: function () {
        this.product.buy((success) => {
            if (success) {
                this.close();
            }
        });
    },

    getButtonText: function () {
        return this.product.getCurrentPrice();
    },

    listBundles: function () {
        return ["extend_unlimited_lives_window"];
    }
});

cleverapps.styles.ExtendUnlimitedLivesWindow = {
    margin: 75,

    padding: {
        bottom: 40
    },

    animation: {
        width: 250,
        height: 250,

        x: { align: "center" },
        y: { align: "center" }
    },

    text: {
        width: 700,
        height: 300
    },

    button: {
        width: 300,
        height: 100
    }
};
